import packageJson from "../package.json";

const APP_VERSION = `v${packageJson.version}`;

export default APP_VERSION;
